export * from './historique.model';
export * from './historique-popup.service';
export * from './historique.service';
export * from './historique-dialog.component';
export * from './historique-delete-dialog.component';
export * from './historique-detail.component';
export * from './historique.component';
export * from './historique.route';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/historique/index.ts